import { Component, computed, inject, input, output } from '@angular/core';
import { Passport } from './passport-chooser.types';
import { FormFieldService } from 'src/app/shared/form-field/services/form-field/form-field.service';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { FormFieldOptions } from 'src/app/shared/form-field/form-field.types';
import { FormFieldComponent } from '../../../../shared/form-field/components/form-field/form-field.component';
import { MatButtonModule } from '@angular/material/button';
import { FormFieldsDirective } from 'src/app/shared/form-field/directives/form-fields/form-fields.directive';

@Component({
  selector: 'app-passport-chooser',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    FormFieldComponent,
    FormFieldsDirective,
  ],
  providers: [FormFieldService],
  templateUrl: './passport-chooser.html',
  styleUrl: './passport-chooser.scss',
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class PassportChooser {
  private fb = inject(FormBuilder);
  private formFieldsService = inject(FormFieldService);
  private langService = inject(LangService);
  labels = this.langService.lang.core.login.passport;

  passports = input<Passport[]>([]);
  passport = output<Passport>();

  passportOptions = computed(() => {
    const passports = this.passports();
    return passports.map(passport => ({
      label: passport.label,
      value: passport.name,
    }));
  });

  form = this.fb.group({
    passport: ['', [Validators.required]],
  });

  onPassport() {
    const passportName = this.form.controls.passport.value;
    const passport = this.passports().find(p => p.name === passportName);
    if (passport) {
      this.passport.emit(passport);
    }
  }

  constructor() {
    this.formFieldsService.configure({
      labels: this.labels.inputs,
      options: {
        passport: FormFieldOptions.select({
          required: true,
        }),
      },
    });
  }
}
